import { MasterLayout } from 'layout/master/main';
import { app } from 'app/app';
import { user } from 'app/user';
import { AppController } from 'app/controller';
import { CompanyCardSlider } from 'module/companyCardSlider/main';
import { Base64Link } from 'module/base64Link/main';
import { JobsListSwitch } from 'module/jobsListSwitch/main';
import { MAIL_NEVER, MAIL_WEEKLY } from 'app/mailSubscriptionInterval';
import { userCompanyFollow } from 'app/userCompanyFollow';
import { userWatchlist } from 'app/userWatchlist';
import { LoadingOverlay } from 'module/loadingOverlay/main';
import { buildUrl } from 'util/url';
import { showSnackbar } from 'util/snackbar';
import 'module/averageSalaryRangeBox/main';
import 'module/proposalButtonList/main';
import './styles.scss';

class ProfessionIndex extends AppController {
    domBindings() {
        return {
            professionIndex: '.c-professionIndex',
            companyCardSlider: '.m-companyCardSlider',
            jobsListSwitch: '.m-jobsListSwitch',
            links: ['.m-base64Link'],
            loadingOverlay: '.m-loadingOverlay',
        };
    }

    getPropsFromDom() {
        return {
            companyAlarmNotificationInterval:
                parseInt(this.dom.professionIndex.getAttribute('data-companyalarmnotificationinterval'), 10),
        };
    }

    subs() {
        this.layout = new MasterLayout(document.documentElement);
        if (this.dom.companyCardSlider) {
            this.companyCardSlider = new CompanyCardSlider(this.dom.companyCardSlider);
        }
        if (this.dom.jobsListSwitch) {
            this.jobsListSwitch = new JobsListSwitch(this.dom.jobsListSwitch);
            this.loadingOverlay = new LoadingOverlay(this.dom.loadingOverlay);
        }
        this.links = [];
        for (let i = 0; i < this.dom.links.length; i += 1) {
            this.links[i] = new Base64Link(this.dom.links[i]);
        }
    }

    subEvents() {
        if (this.jobsListSwitch) {
            this.jobsListSwitch.events.on('showOverlay', () => {
                this.loadingOverlay.show();
            });

            this.jobsListSwitch.events.on('hideOverlay', () => {
                this.loadingOverlay.hide();
            });
            this.jobsListSwitch.events.on(
                'changedLocation',
                (searchRequest) => {
                    window.location.href = buildUrl(`/jobs/${searchRequest.arguments[0].locationSlug}`);
                },
            );
        }
        if (!user.isLoggedIn()) {
            userWatchlist.events.on('onUnauthorized', (watchlistObject) => {
                this.layout.openLoginModal(watchlistObject.arguments[0].watchlistObject.state, true);
            });
            userCompanyFollow.events.on('onUnauthorized', (followObject) => {
                this.layout.openLoginModal(followObject.arguments[0].companyFollowObject.state, true);
            });
        } else {
            userCompanyFollow.events.on('onAddJob', () => {
                let snackbarText;
                if (this.props.companyAlarmNotificationInterval === MAIL_WEEKLY) {
                    snackbarText = 'Ab sofort erhältst du wöchentlich neue Jobs dieser Firma per E-Mail.';
                } else {
                    snackbarText = 'Ab sofort erhältst du täglich neue Jobs dieser Firma per E-Mail.';
                }

                showSnackbar({
                    text: snackbarText,
                    icon: false,
                    link: '/settings/notifications#c-notificationIndex-companyalarm',
                    linkText: 'Anpassen',
                });
            });
            userCompanyFollow.events.on('onRemoveJob', () => {
                if (this.props.companyAlarmNotificationInterval !== MAIL_NEVER) {
                    showSnackbar({
                        text: 'Du erhältst ab sofort keine Jobs dieser Firma mehr per E-Mail.',
                    });
                }
            });
            userCompanyFollow.events.on('onFollowError', (error) => {
                [].forEach.call(error.arguments[0].errors, (err) => {
                    if (err.meta.company_follow_max_limit) {
                        showSnackbar({
                            text: 'Oje, du hast das Maximum schon erreicht! Um dieser Firma zu folgen, '
                            + 'entfolge einer anderen Firma.',
                            link: '/companyalarm?openAccordion=true',
                            linkText: 'Zum Firmen-Alarm ',
                        });
                    }
                });
            });
        }
    }
}

app.boot(ProfessionIndex);

if (module.hot) {
    module.hot.accept(module.children, () => {
        // eslint-disable-next-line no-console
        console.log('Rebooting controller due to HMR...');
        app.boot(ProfessionIndex);
    });

    module.hot.accept(() => {});
}
